const I18CONSTANTS = {
  questionForUs: 'questionForUs',
  loveToHearFromYou: 'loveToHearFromYou',
  wantToKnow: 'wantToKnow',
  wantToKnowPlaceholder: 'wantToKnowPlaceholder',
  letUsKnow: 'letUsKnow',
  contactInfoTitle: 'contactInfoTitle',
  firstNamePlaceholder: 'firstNamePlaceholder',
  lastNamePlaceHolder: 'lastNamePlaceHolder',
  phonePlaceholder: 'phonePlaceholder',
  emailPlaceholder: 'emailPlaceholder',
  cancelButtonText: 'cancelButtonText',
  submitButtonText: 'submitButtonText',
  recaptchaLabel: 'recaptchaLabel',
  haveQuestion: 'haveQuestion',
  enterQuestionPlaceholder: 'enterQuestionPlaceholder',
  refineItemsHeader: 'refineItemsHeader',
  searchResultHeader: 'searchResultHeader',
  selectATopic: 'selectATopic',
  pleaseSelect: 'pleaseSelect',
  popoverDoneButton: 'popoverDoneButton',
  feedbackSuccess: 'feedbackSuccess',
  feedbackSuccessMessage: 'feedbackSuccessMessage',
  feedbackSuccessOk: 'feedbackSuccessOk',
  feedbackHelpText: 'feedbackHelpText',
  firstNameHelpText: 'firstNameHelpText',
  lastNameHelpText: 'lastNameHelpText',
  phoneHelpText: 'phoneHelpText',
  emailHelpText: 'emailHelpText',
  mandatorynote: 'mandatorynote',
  Australia: 'Australia',
};

export default I18CONSTANTS;

export const CONTACTKFCCONSTANTS = {
  MEDIA_ENQUIRY: 'Media Enquiry',
  POSTCODE: 'postcode',
  ORDER_NUMBER: 'ordernumber',
  SORTVISIT: 'sortvisit',
  SORTMEAL: 'sortmeal',
  ORDER_DATE: 'orderdate',
  ORDER_TIME: 'ordertime',
  VISITEDDATE: 'visiteddate',
  VISITEDTIME: 'visitedtime',
  DETAILSAREA: 'detailsArea',
  PHONENUMBER: 'phonenumber',
  EMAIL: 'emailaddress',
  HELPDD: 'helpDDOptions',
  ENQUIRYDD: 'enquiryDDOptions',
  SPECIFICDD: 'specificDDOptions',
  ADDRESSNAME: 'addressName',
  FULLNAME: 'fullname',
  ENQUIRY_DETAILS: 'enquirydetails',
  PUBLICATION_DETAILS: 'publicationdetails',
  PUBLICATION_DETAILS_MAXLENGTH: 250,
  PHONE: 'phone',
  EMAILID: 'email',
  MESSAGE: 'message',
  CONFIRMATION: 'confirmation',
  THANKSMESSAGE: 'thanksMessage',
  NO: 'No',
  SUCCESSRESPONSE: 201,
  DDSELECTONE: '- Select One -',
  APPENQUIRY: 'KFC App Enquiry',
};

export const CONTACTKFC_UTILS = {
  FIRSTNAME: 'firstName',
  LASTNAME: 'lastName',
  CALLNATURE: 'callNature',
  CATEGORY: 'category',
  SUBCODE: 'subcode',
  DESCRIPTION: 'description',
  PHONE: 'phone',
  EMAIL: 'email',
  STOREID: 'storeID',
  TYPEOFVISIT: 'typeOfVisit',
  TYPEOFMEAL: 'typeOfMeal',
  ORDER_NUMBER: 'orderNumber',
  VISITDATE: 'visitDate',
  VISITTIME: 'visitTime',
  LANGUAGE: 'language',
};
